export const chartDomainChecker = (
  chartDomain: [x: string | number, y: string | number]
) => {
  if (chartDomain[0] === 0 && chartDomain[1] === 0) {
    return undefined;
  }
  return chartDomain;
};
